module.exports = __webpack_public_path__ + "640.fdca11c5.jpg";